export default {
  desktopThreshold: 940,
  googleApiKey: 'AIzaSyBPaP-oOOmeVMM68WGg42RDXsucpcrhjEI',
  googleImagePath: import.meta.env.PROD ? '/etc/clientlibs/frontend/sanitas-ovp-webpack/img/google/' : './img/google/',
  microserviceBaseUrl: import.meta.env.VITE_SANITAS_MICROSERVICE_URI,
  resourceBaseUrl: import.meta.env.VITE_SANITAS_RESOURCE_URI,
  unbluServerUrl: 'https://unblu.cloud',
  unbluApiKey: 'LLviJ-mFR0i957NPwwhB7Q',
}
